import { AgileIcon, BoardIcon, DashboardIcon, PieChartIcon } from '@sketchnote/icons';
import { useRouter } from 'next/router';
import { useAgileStore } from 'src/features/scrum/store';

interface AgileNavBarProps {
  file: string;
}

export const AgileNavBar = ({ file }: AgileNavBarProps) => {
  const router = useRouter();
  const { selectedView, setSelectedView } = useAgileStore();
  const isAgile = router?.query?.type === 'agile';
  const orgId = router?.query?.orgId;
  const mode = router?.query?.mode;

  return (
    <>
      <button
        onClick={() => {
          router.push(`/${mode}/${orgId}/files/${router.query.slug}?view=${file}&type=agile`);
          setSelectedView('sprints');
        }}
      >
        <a>
          <div
            className={`font-medium relative mt-1 flex items-center text-sm ${
              isAgile && selectedView === 'sprints' ? 'text-blue-500' : 'text-gray-500'
            }`}
          >
            <span className="block mr-4 mt-2">
              <AgileIcon />
            </span>
            <span>Backlog</span>
          </div>
        </a>
      </button>
      <div className="flex flex-row">
        <span className="mx-12 block text-gray-500">|</span>
        <button
          onClick={() => {
            router.push(`/${mode}/${orgId}/files/${router.query.slug}?view=${file}&type=agile`);
            setSelectedView('epics');
          }}
        >
          <a>
            <div
              className={`font-medium relative mt-1 flex items-center text-sm ${
                isAgile && selectedView === 'epics' ? 'text-blue-500' : 'text-gray-500'
              }`}
            >
              <span className="block mr-4 mt-2">
                <AgileIcon />
              </span>
              <span>Epics</span>
            </div>
          </a>
        </button>
      </div>
      <div className="flex flex-row">
        <span className="mx-12 block text-gray-500">|</span>
        <button
          className="flex relative"
          onClick={() => {
            router.push(`/${mode}/${orgId}/files/${router.query.slug}?view=${file}&type=agile`);
            setSelectedView('board');
          }}
        >
          <div
            className={`font-medium relative mt-1 flex items-center text-sm ${
              isAgile && selectedView === 'board' ? 'text-blue-500' : 'text-gray-500'
            }`}
          >
            <span className="block mr-4 mt-2">
              <BoardIcon />
            </span>
            <span className="capitalize mr-6">Sprint board</span>
          </div>
        </button>
        <span className="mx-12 block text-gray-500">|</span>
        <button
          className="flex relative"
          onClick={() => {
            router.push(`/${mode}/${orgId}/files/${router.query.slug}?view=${file}&type=agile`);
            setSelectedView('analytics');
          }}
        >
          <div
            className={`font-medium relative mt-1 flex items-center text-sm ${
              isAgile && selectedView === 'analytics' ? 'text-blue-500' : 'text-gray-500'
            }`}
          >
            <span className="block mr-4 mt-2">
              <PieChartIcon />
            </span>
            <span className="capitalize mr-6">Analytics</span>
          </div>
        </button>
      </div>
    </>
  );
};
